<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">下单时间{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange1" :clearable="false"></myDatePicker></div>
                <div class="f-bd f14 text-nowrap">完成时间{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id2" @onChange="onDateChange2"></myDatePicker></div>
                <template v-if="show_search_all">
                    <div class="mg-right5 mg-top5">
                        <el-input size="small" class="width-300" v-model="search.order_code">
                            <span slot="prepend">平台订单{{$t('x_dd')}}</span>
                        </el-input>
                    </div>
                    <div class="mg-right5 mg-top5">
                        <el-input size="small" class="width-300" v-model="search.guest_order_code">
                            <span slot="prepend">客户订单{{$t('x_dd')}}</span>
                        </el-input>
                    </div>
                    <div class="mg-right5 mg-top5">
                        <el-input size="small" class="width-250" v-model="search.mobile">
                            <span slot="prepend">手机号码{{$t('x_dd')}}</span>
                        </el-input>
                    </div>
                    <div class="mg-right5 mg-top5">
                        <el-input size="small" class="width-250" v-model="search.bat_code">
                            <span slot="prepend">批次号{{$t('x_dd')}}</span>
                        </el-input>
                    </div>
                    <div class="mg-right5 mg-top5 flex-box nopadding">
                        <div class="text-hd small">商品{{$t('x_dd')}}</div>
                        <el-select size="small" class="fillw" v-model="search.goods_id" clearable filterable @change="list()">
                            <el-option :label="item.goods_cname"  v-for="(item, index) in goods_id" :value="item.goods_id" :key="item.goods_id"></el-option>
                        </el-select>
                    </div>
                </template>
                <div class="mg-right5 mg-top5">
                    <myShowHeaderBtn></myShowHeaderBtn>
                </div>
                <div class="mg-right5 mg-top5">
                    <myShowHideBtn v-model="show_search_all"></myShowHideBtn>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed min-width="150px">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.goods_cname" :list="goods_id" v-model="search.goods_id"
                                        title_class="f12 f-blue" key_name="goods_cname" value_name="goods_id" @onChange="list()"></myDropdown>
                        </template>
                        <el-table-column label-class-name="f-red pd-top0" min-width="150px">
                            <template slot-scope="scope" slot="header">合计</template>
                            <div slot-scope="scope">{{scope.row.goods_cname}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.goods_amt" v-if="!listHeaderHide.goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.guest_cost_amt" v-if="!listHeaderHide.guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div class="f-blue" slot-scope="scope" slot="header">{{totalData.sum.guest_cost_amt * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="mobile" :label="listHeader.mobile" min-width="110px" v-if="!listHeaderHide.mobile"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" min-width="170px" v-if="!listHeaderHide.add_time"></el-table-column>
                    <el-table-column min-width="120px" prop="mobile_mac_cdesc" v-if="!listHeaderHide.mobile_mac_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.mobile_mac_cdesc" :list="mobile_mac" v-model="search.mobile_mac"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                        <div slot-scope="scope">
                            {{scope.row.mobile_mac_cdesc}}<span v-if="scope.row.guishu != ''">，{{scope.row.guishu}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column min-width="90px" prop="order_from_cdesc" v-if="!listHeaderHide.order_from_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.order_from_cdesc" :list="order_from" v-model="search.order_from"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="90px" :label="listHeader.use_minute" v-if="!listHeaderHide.use_minute">
                        <template slot-scope="scope">{{scope.row.use_minute}}</template>
                    </el-table-column>
                    <el-table-column fixed="right" min-width="120px" v-if="!listHeaderHide.order_status_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.order_status_cdesc" :list="order_status" v-model="search.order_status"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                        <div slot-scope="scope">{{scope.row.order_status_cdesc}}</div>
                    </el-table-column>
                    <el-table-column prop="vendor_remark" :label="listHeader.vendor_remark" min-width="150px" v-if="!listHeaderHide.vendor_remark"></el-table-column>
                    <el-table-column :label="listHeader.guest_back_url" min-width="250px" v-if="!listHeaderHide.guest_back_url">
                        <div slot-scope="scope">
                            <div class="mg-bottom5">{{scope.row.guest_back_url}}</div>
                            <el-tag size="small">已回调{{scope.row.guest_back_url_qty}}次</el-tag>
                            <el-tag size="small" v-if="scope.row.guest_back_ok == '1'">回调成功</el-tag>
                        </div>
                    </el-table-column>
                    <el-table-column :label="listHeader.order_code" min-width="180px" v-if="!listHeaderHide.order_code">
                        <div class="f-brown" slot-scope="scope">{{scope.row.order_code}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.guest_order_code" min-width="180px" v-if="!listHeaderHide.guest_order_code">
                        <div slot-scope="scope">{{scope.row.guest_order_code}}</div>
                    </el-table-column>
                    <el-table-column prop="bat_code" :label="listHeader.bat_code" min-width="160px" v-if="!listHeaderHide.bat_code"></el-table-column>
                    <el-table-column prop="over_time" :label="listHeader.over_time" min-width="170px" v-if="!listHeaderHide.over_time"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDropdown from "../../../components/myDropdown";
import myDatePicker from "../../../components/myDatePicker";
import myShowHideBtn from "../../../components/myShowHideBtn";
import myShowHeaderBtn from "../../../components/myShowHeaderBtn";
import excel from '../../../utils/excel'
export default {
    name:'gorder-c',
    components:{
        myPager,
        myDropdown,
        myDatePicker,
        myShowHideBtn,
        myShowHeaderBtn
    },
    data: function(){
        const listHeader = {
            goods_cname: '商品',
            goods_amt: '面值',
            guest_cost_amt: '结算价',
            mobile: '手机号码',
            add_time: '下单时间',
            mobile_mac_cdesc: '运营商',
            guishu: '归属',
            order_from_cdesc: '来源',
            use_minute: '耗时(分钟)',
            order_status_cdesc: '状态',
            vendor_remark: '备注',
            guest_back_url: '回调地址',
            guest_back_url_qty: '已回调次数',
            guest_back_ok_cdesc: '回调成功',
            order_code: '平台订单号',
            guest_order_code: '客户订单号',
            bat_code: '批次号',
            over_time: '完成时间'
        }
        return{
            relist: false,
            show_subview: false,
            show_search_all: false,
            excel_frow_num: 2, //固定两行
            excel_fcol_num: 1, //固定三列
            search:{
                search_url: 'gorder-c/list',
                datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                datearea_id2:0,
                over_time_fr: '',
                over_time_to: '',
                page: 1,
                pageSize: 0,
                limit:'20',
                order_code: "",
                guest_order_code:'',
                mobile:'',
                order_from:'',
                goods_cname:'',
                order_status:'',
                bat_code:''
            },
            listHeader,
            listHeaderHide:{},
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
            order_status:[
                {
                    key:'',
                    value:'全部'
                }
            ],
            order_from:[
                {
                    key:'',
                    value:'全部'
                }
            ],
            mobile_mac:[
                {
                    key:'',
                    value:'全部'
                }
            ],
            goods_id:[
                {
                    goods_id:'',
                    goods_cname:'全部'
                }
            ],
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.getLoad();
        });
    },
    methods: {
        onDateChange1: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onDateChange2: function(data){
            this.search.vendor_rs_time_fr = data[0];
            this.search.vendor_rs_time_to = data[1];
            this.list()
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        getLoad: function () {
            this.$base.showLoading();
            this.$request.sendPost("gorder-c/before-list",{},(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.order_status = this.order_status.concat(data.order_status);
                    this.order_from = this.order_from.concat(data.order_from);
                    this.mobile_mac = this.mobile_mac.concat(data.mobile_mac);
                    this.goods_id = this.goods_id.concat(data.goods_id);
                    this.list();
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/gorder/c/list.vue